import { render } from "./QzInfo.vue?vue&type=template&id=1f8dec26&scoped=true"
import script from "./QzInfo.vue?vue&type=script&lang=js"
export * from "./QzInfo.vue?vue&type=script&lang=js"

import "./QzInfo.vue?vue&type=style&index=0&id=1f8dec26&scoped=true&lang=css"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8dec26"]])

export default __exports__